/* eslint-disable no-barrel-files/no-barrel-files */
// TODO: De-barrel-ize
import {
  TermsModalProvider,
  useTermsModal,
} from 'features/terms/TermsOfServiceProvider'

export { TermsModalProvider, useTermsModal }
